import {auth} from './firebase'

export default async function sendPasswordResetEmail  (email) {
    try {
      await auth.sendPasswordResetEmail(email);
      alert("Password reset link sent!");
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };